<script>
import { Field } from 'vant'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'toggle-button-group',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-field': Field,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        items: Array,
        inputMode: Boolean,
        inputLabel: String,
        inputPlaceholder: String,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            toggleButtons: [],
            isInputField: false,
            inputFieldValue: null,
        }
    },

    watch: {
        items(value) {
            // console.log('watch checked', value)
            this.toggleButtons = ObjectFunc.cloneObject(value) || []
        }
    },
    
    mounted() {
        // console.log('mounted', this.checked)
        this.toggleButtons = ObjectFunc.cloneObject(this.items) || []
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onToggleBtnClick(item) {
            item.selected = !item.selected
            this.changeData()
        },
        onInputBtnClick() {
            this.isInputField = true
        },
        onInputFieldBlur() {
            this.isInputField = false
            const value = this.inputFieldValue.trim()
            if (value) {
                this.toggleButtons.push({
                    label: value,
                    selected: true
                })
                this.inputFieldValue = null
                this.changeData()
            }
        },
        onBlankAreaClick() {
            this.isInputField = false
        },
        changeData() {
            this.$emit('change-data', ObjectFunc.cloneObject(this.toggleButtons))
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="toggle-button-group relative">
        <div class="group-container u-outer-padding bg-white" @click="onBlankAreaClick">
            <div
                v-for="item in toggleButtons"
                :key="item.label"
                class="inline-block r-inner-margin"
                @click.stop="onToggleBtnClick(item)"
            >
                <div v-if="item.selected" class="bg-primary border-primary corner-round-sm b-inner-margin">
                    <div class="u-outer-padding">
                        <span class="main-text color-white">{{ item.label }}</span>
                    </div>
                </div>
                <div v-else class="bg-white border-primary corner-round-sm b-inner-margin">
                    <div class="u-outer-padding">
                        <span class="main-text primary-color">{{ item.label }}</span>
                    </div>
                </div>
            </div>
            <div
                v-if="inputMode"
                class="inline-block r-inner-margin"
                @click.stop="onInputBtnClick"
            >
                <div class="bg-white border-primary dashed corner-round-sm b-inner-margin">
                    <div v-if="!isInputField" class="u-outer-padding">
                        <span><i class="iconfont iconfont-add primary-color"/></span>
                        <span v-if="inputLabel" class="main-text primary-color l-inner-margin">{{ inputLabel }}</span>
                    </div>
                    <div v-else style="width: calc(100vw - 34px);">
                        <van-field
                            v-model="inputFieldValue"
                            :placeholder="inputPlaceholder"
                            clearable
                            maxlength="20" 
                            @blur="onInputFieldBlur"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="separator-line-bottom"/>
    </div>
</template>